// extracted by css-extract-rspack-plugin
export default {"stores-container":"AllStores-module__stores-container--mLseq"};